import React from "react";

const iconProps = {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
};

const ServiceIcon = ({ name }) => {
    switch (name) {
        case "auth":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <path d="M12 3l7 4v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V7l7-4z" />
                    <path d="M9.5 12l1.8 1.8 3.7-4" />
                </svg>
            );
        case "contracts":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <rect height="7" rx="1.5" width="7" x="4" y="4" />
                    <rect height="7" rx="1.5" width="7" x="13" y="4" />
                    <rect height="7" rx="1.5" width="7" x="4" y="13" />
                    <rect height="7" rx="1.5" width="7" x="13" y="13" />
                </svg>
            );
        case "deliverables":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <path d="M8 3h8l4 4v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
                    <path d="M16 3v5h4" />
                    <path d="M10 13l-2 2 2 2" />
                    <path d="M16 13l2 2-2 2" />
                    <path d="M13.5 12l-3 6" />
                </svg>
            );
        case "endpoints":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <circle cx="6" cy="12" r="2" />
                    <circle cx="18" cy="6" r="2" />
                    <circle cx="18" cy="18" r="2" />
                    <path d="M8 11l8-4" />
                    <path d="M8 13l8 4" />
                </svg>
            );
        case "face":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <path d="M8 3H5a2 2 0 0 0-2 2v3" />
                    <path d="M16 3h3a2 2 0 0 1 2 2v3" />
                    <path d="M8 21H5a2 2 0 0 1-2-2v-3" />
                    <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
                    <circle cx="12" cy="10" r="3" />
                    <path d="M7.5 17a5.5 5.5 0 0 1 9 0" />
                </svg>
            );
        case "list":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <rect height="16" rx="2" width="18" x="3" y="4" />
                    <path d="M8 9h8" />
                    <path d="M8 13h8" />
                    <path d="M8 17h5" />
                </svg>
            );
        case "schemas":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" />
                    <path d="M12 12l8-4.5" />
                    <path d="M12 12v9" />
                    <path d="M12 12L4 7.5" />
                </svg>
            );
        case "screen":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <rect height="12" rx="2" width="18" x="3" y="4" />
                    <path d="M8 20h8" />
                    <path d="M12 16v4" />
                </svg>
            );
        case "services":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <path d="M12 3l8 4-8 4-8-4 8-4z" />
                    <path d="M4 12l8 4 8-4" />
                    <path d="M4 17l8 4 8-4" />
                </svg>
            );
        case "user":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 21a8 8 0 0 1 16 0" />
                </svg>
            );
        case "version":
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <path d="M20 13l-7 7-9-9V4h7l9 9z" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                </svg>
            );
        case "doc":
        default:
            return (
                <svg aria-hidden="true" {...iconProps}>
                    <path d="M7 3h7l4 4v14H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
                    <path d="M14 3v5h5" />
                    <path d="M9 13h6" />
                    <path d="M9 17h6" />
                </svg>
            );
    }
};

export default ServiceIcon;
